module.exports = __webpack_public_path__ + "static/media/mobile-app-promotion-nl.7aa463a5.png";